<template>

	<form-group :no-wrap="!label" 
		:col-class="colClass" 
		:class="{'text-danger':invalid, 'invalid-group': invalid}" 
		:label="label" 
		:align-label-right="alignLabelRight"
		:control-left="controlLeft"
		v-on:clickLabel="$emit('clickLabel')">

		<div :class="{'float-right': floatControlRight}">

			<textarea 
				v-if="localParams.type == 'textarea' && !readonly" 
				class="form-control"
				:class="textareaClasses"
				:ref="randKey"
				:maxlength="'maxlength' in localParams ? localParams.maxlength : null"
				:rows="'rows' in localParams ? localParams.rows : null"
				v-model="localValue" 
				:placeholder="localParams.placeholder" 
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				v-on:focus="focusSet"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:keyup="keyUp(localValue)"
				v-on:blur="blur"
				v-on:click="$emit('click')">
			</textarea>

			<pre 
				class="readonly-pre" :class="localParams.size"
				v-else-if="localParams.type == 'textarea' && readonly" 
				:style="localParams.style ? localParams.style : ''">{{localValue}}</pre>

			<template v-else-if="localParams.type == 'richtext'">
				<div 
					class="readonly-div" 
					v-if="readonly"
					v-html="stripInlineEventHandlers(localValue)">		
				</div>

				<editor
					v-else 
					tinymce-script-src="https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.10.9/tinymce.min.js"
					:init="tinymceInit()"
					v-model="localValue"
					v-on:input="updateValue(localValue)">		
				</editor>

				<!--<rich-text
					v-show="!readonly"
					:destroy="readonly"
					:class="{invalid: invalid}"
					:height="localParams.height ? localParams.height : '200px'"
					:name="'editor_'+randKey"
					:id="'editor_'+randKey"
					:init="localParams.init ? localParams.init : {
						plugins: 'link lists advlist hr code pagebreak autoresize',
						toolbar: 'bold bullist numlist | undo redo | code',
						menubar: false
					}"
					v-model="localValue"
					v-on:input="updateValue(localValue)"
					v-on:focus="focus"> 
				</rich-text>-->
			</template>

			<date-picker 
				v-else-if="localParams.type=='date' && !readonly"
				:class="{invalid: invalid}"
				v-model="localValue"
				:initial-date="localParams.initialDate"
				:style="localParams.style ? localParams.style : ''"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:click="$emit('click')">
			</date-picker>


			<date-time-picker 
				v-else-if="localParams.type=='datetime' && !readonly"
				:class="{invalid: invalid}"
				v-model="localValue"
				:initial-date="localParams.initialDate"
				:style="localParams.style ? localParams.style : ''"
				:input-in-utc="localParams.inputInUtc ? localParams.inputInUtc : false"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:click="$emit('click')">
			</date-time-picker>

			<input v-else-if="(localParams.type=='date' || localParams.type == 'time') && !readonly"
				:type="localParams.type" class="form-control" 
				:placeholder="localParams.placeholder"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:class="{invalid: invalid}"
				:ref="randKey"
				:name="randKey"
				:autocomplete="localParams.autocomplete || 'on'"
				v-model="localValue" 
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:keyup="keyUp(localValue)"
				v-on:focus="focusSet"
				v-on:blur="blur"
				v-on:click="$emit('click')">

			<input v-else-if="localParams.type=='number' && !readonly" 
				type="number" 
				:ref="randKey"
				:name="randKey"
				:min="localParams.min"
				:max="localParams.max" 
				:step="localParams.step" 
				class="form-control" 
				:class="{invalid: invalid,'text-right':localParams.align == 'right'}"
				:placeholder="localParams.placeholder"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:autocomplete="localParams.autocomplete || 'on'"
				v-model="localValue" 
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:keyup="keyUp(localValue)"
				v-on:focus="focusSet"
				v-on:blur="blur"
				v-on:click="$emit('click')">

			<button-group v-else-if="localParams.type=='btn-group'" 
				:buttons="localParams.buttons"
				:large-buttons="localParams.largeButtons"
				:style="localParams.style ? localParams.style : ''"
				:readonly="readonly"
				:class="{invalid: invalid}"
				:tab-styling="localParams.tabStyling ? localParams.tabStyling : false"
				:disable-null="'disableNull' in localParams ? localParams.disableNull : false"
				:disabled="disabled"
				v-model="localValue" 
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)">
			</button-group>

			<div v-else-if="localParams.type=='boolean' && localParams.doubleLabels && !readonly" class="d-flex flex-row align-items-center">
				<label class="switch-label ml-0">{{localParams.doubleLabels[0]}}</label>
				<switch-control
					v-model="localValue" 
					v-on:input="fieldChanged(localValue)">
				</switch-control>
				<label class="switch-label">{{localParams.doubleLabels[1]}}</label>
			</div>

			<div v-else-if="localParams.type=='boolean' && ('checkbox' in localParams && localParams.checkbox) && !readonly" :class="{'checkbox-container': ('stacked' in localParams && localParams.stacked)}">
				<label class="checkbox-label">
					<input
						type="checkbox"
						v-model="localValue"
						v-on:change="fieldChanged(localValue)"
						v-on:click="$emit('click')">
					<span class="ml-2" v-html="stripInlineEventHandlers(('text' in localParams) ? localParams.text : localParams)"></span>
				</label>
			</div>

			<switch-control v-else-if="localParams.type=='boolean' && !readonly"
				:style="{marginLeft: controlLeft ? '' : '10px'}"
				v-model="localValue" 
				v-on:input="fieldChanged(localValue)">
			</switch-control>

			<label class="col-form-label" v-else-if="localParams.type == 'boolean' && localParams.doubleLabels && readonly">
				<div v-if="!localValue">{{localParams.doubleLabels[0]}}</div>
				<div v-else>{{localParams.doubleLabels[1]}}</div>
			</label>

			<div v-else-if="localParams.type == 'boolean' && readonly">
				<i class="fa" :class="{'fa-check':localValue,'fa-times':!localValue || localValue == 0}"></i>
				<span v-if="'text' in localParams" class="ml-2" v-html="stripInlineEventHandlers(localParams.text)"></span>
			</div>

			<select v-else-if="localParams.type=='native-select' && !readonly" 
				v-model="localValue" 
				class="form-control"
				:class="{invalid: invalid}" 
				:readonly="readonly"
				:ref="randKey"
				v-on:input="updateValue(localValue)" 
				v-on:click="fieldChanged(localValue)"
				v-on:blur="blur">

				<option v-if="'placeholder' in localParams" selected="true" disabled="true" value="0">
					{{localParams.placeholder}}
				</option>

				<option v-for="option in localParams.options" :value="option.value ? option.value : option" :disabled="'disabled' in option && option.disabled">
					{{'text' in option ? option.text : option}}
				</option>
			</select>

			<multi-select v-else-if="localParams.type=='select' && !readonly"
				:options="localParams.options" 
				:multiple="false"
				:readonly="readonly"
				:placeholder="'placeholder' in localParams ? localParams.placeholder : null"
				:class="{invalid: invalid}"
				:grouped="localParams.grouped ? localParams.grouped : false"
				:loading="loading"
				:disable-search="'disableSearch' in localParams ? localParams.disableSearch : false"
				v-model="localValue" 
				v-on:searchChange="$emit('searchChange',$event)"
				v-on:change="fieldChanged(localValue)"
				v-on:click="$emit('click')"
				v-on:open="$emit('open')"
				v-on:close="$emit('close')">
			</multi-select>

			<div v-else-if="localParams.type == 'checklist' && !readonly">

				<div v-for="option in localParams.options" class="checkbox-container" 
					:class="{
						'checkbox-container': ('stacked' in option && option.stacked),
						'checkbox-container-horizontal' : 'horizontalChecklist' in localParams && localParams.horizontalChecklist
					}">

					<label class="checkbox-label">
						<input type="checkbox" 
							:value="option.value"
							v-model="localValue" 
							v-on:change="fieldChanged(localValue)"
							v-on:click="$emit('click')">
						<span class="ml-2" v-html="stripInlineEventHandlers(('text' in option) ? option.text : option)"></span>
					</label>
				</div>
			</div>

			<div v-else-if="(localParams.type == 'checklist' || localParams.type == 'select-multi') && readonly">

				<div v-for="val in localValue">
					<i class="fa fa-check-square"></i>

					<template v-if="localParams.options.find(option => val == option)">
						{{localParams.options.find(option => val == option)}}
					</template>

					<template v-else-if="localParams.options.find(option => ('value' in option && val == option.value))">
						{{localParams.options.find(option => val == option.value).text}}
					</template>

				</div>
			</div>

			<input v-else-if="localParams.type == 'select' && readonly"
				readonly 
				:ref="randKey"
				:name="randKey"
				:value="selectReadonlyValue"
				class="form-control-plaintext"
				:style="localParams.style ? localParams.style : ''">

			<multi-select v-else-if="localParams.type=='select-multi' && !readonly"
				:options="localParams.options" 
				:multiple="true"
				:readonly="readonly"
				:class="{invalid: invalid}"
				:loading="loading"
				:expanded-style="'expandedStyling' in localParams && localParams.expandedStyling"
				:grouped="localParams.grouped ? localParams.grouped : false"
				:placeholder="'placeholder' in localParams ? localParams.placeholder : null"
				:close-on-select="'closeOnSelect' in localParams ? localParams.closeOnSelect : true"
				v-on:searchChange="$emit('searchChange',$event)"
				v-model="localValue" 
				v-on:change="fieldChanged(localValue)"
				v-on:open="$emit('open')"
				v-on:close="$emit('close')">
			</multi-select>

			<input v-else-if="localParams.type == 'select-multi' && readonly"
				 readonly
				 :ref="randKey"
				 :name="randKey"
				 :value="selectReadonlyValue"
				 class="form-control-plaintext"
				 :style="localParams.style ? localParams.style : ''" />

			<!--<input v-else-if="(localParams.type == 'select' || localParams.type == 'select-multi') && !readonly && localParams.options.length == 0"
				readonly 
				value="loading options..."
				class="form-control-plaintext"
				:ref="randKey"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''">-->

			<pallette-picker v-else-if="localParams.type == 'color-picker'"
				:colors="localParams.colors"
				:show-deselect="'hideDeselect' in localParams ? localParams.hideDeselect : false "
				v-on:change="fieldChanged(localValue)"
				v-on:input="fieldChanged(localValue)"
				v-model="localValue">
			</pallette-picker>

			<select v-else-if="localParams.type == 'province' && !readonly"
				v-model="localValue" 
				class="form-control" 
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:class="{invalid: invalid}"
				:ref="randKey"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)" 
				v-on:click="fieldChanged(localValue)"
				v-on:blur="blur">

				<option v-for="option in provincesAndStates" :value="option.value" :disabled="'disabled' in option ? option.disabled : false">{{option.text}}</option>
				
			</select>

			<multi-select v-else-if="localParams.type=='months-select' && !readonly"
				:options="calendarMonths" 
				:multiple="false"
				:readonly="readonly"
				:placeholder="'placeholder' in localParams ? localParams.placeholder : null"
				:class="{invalid: invalid}"
				:grouped="localParams.grouped ? localParams.grouped : false"
				:loading="loading"
				v-model="localValue" 
				v-on:searchChange="$emit('searchChange',$event)"
				v-on:change="fieldChanged(localValue)"
				v-on:click="$emit('click')"
				v-on:open="$emit('open')"
				v-on:close="$emit('close')">
			</multi-select>

			<input v-else-if="localParams.type == 'province' && readonly"
				type="text"
				class="form-control-plaintext"
				:name="randKey"
				v-model="localValue">

			<div v-else-if="localParams.type == 'table'" style="overflow-x: auto;" v-on:click="$emit('click')">
				<table class="table">

					<tr v-if="localParams.columns">
						<th v-if="localParams.rows"></th>
						<th v-for="col in localParams.columns">
							{{typeof(col) == 'object' ? col.text : col}}
						</th>
					</tr>

					<tr v-for="(row, rowIndex) in localValue">

						<th v-if="localParams.rows">
							{{typeof(localParams.rows[rowIndex]) == 'object' ? localParams.rows[rowIndex].text : localParams.rows[rowIndex]}}
						</th>

						<td v-for="(col, index) in row">

							<field
								v-if="localParams.columns && typeof(localParams.columns[index]) == 'object'"
								:params="{readonly, ...col.params}"
								v-model="row[index]"

								v-on:input="updateValue(localValue)"
								v-on:change="fieldChanged(localValue)"
								v-on:focus="focusSet"
								v-on:keyup="keyUp(localValue)"
								v-on:blur="blur"
								v-on:click="$emit('click')">
							</field>

							<input
								type="text"
								class="form-control"
								v-model="row[index]"
								:readonly="readonly"
								style="min-width: 100px"
								v-on:input="updateValue(localValue)"
								v-on:change="fieldChanged(localValue)"
								v-on:focus="focusSet"
								v-on:keyup="keyUp(localValue)"
								v-on:blur="blur"
								v-on:click="$emit('click')"/>

						</td>

					</tr>

				</table>

				<button v-if="!localParams.rows && !readonly" type="button" class="btn btn-primary btn-sm mr-2" v-on:click="addTableRow">
					<i class="fa fa-plus"></i>
					Add Row
				</button>

				<button v-if="!localParams.columns && !readonly" type="button" class="btn btn-primary btn-sm" v-on:click="addTableColumn">
					<i class="fa fa-plus"></i>
					Add Column
				</button>

			</div>


			<input v-else-if="localParams.type == 'static' || readonly"
				readonly v-model="localValue"
				class="form-control-plaintext"
				:class="{'text-right':localParams.align == 'right'}"
				:name="randKey"
				:ref="randKey"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:autocomplete="localParams.autocomplete || 'on'"
				v-on:click="$emit('click')">

			<div v-else-if="localParams.type == 'editable-static'"
				class="d-flex flex-row align-items-center editable-static" 
				v-on:click="$emit('click')">

				<i class="fa mr-2" :class="{
					'fa-pencil-alt' : !localParams.working,
					'fa-spin fa-spinner' : localParams.working
				}"></i>
				<input readonly v-model="localValue"
					class="form-control-plaintext"
					:ref="randKey"
					:style="localParams.style ? localParams.style : ''">
			</div>

			<input v-else-if="localParams.type == 'password'"
				v-model="localValue"
				class="form-control"
				:class="{invalid: invalid}"
				type="password"
				:placeholder="localParams.placeholder"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:ref="randKey"
				:name="randKey"
				:autocomplete="localParams.autocomplete || 'on'"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:focus="focusSet"
				v-on:blur="blur"
				v-on:click="$emit('click')">

			<input v-else-if="localParams.type == 'color'" 
				type="color"
				v-model="localValue"
				class="form-control"
				:class="{invalid: invalid}"
				:placeholder="localParams.placeholder"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:ref="randKey"
				:name="randKey"
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:focus="focusSet"
				v-on:blur="blur"
				v-on:click="$emit('click')">

			<input v-else 
				type="text" 
				class="form-control" 
				:class="{invalid: invalid}"
				:placeholder="localParams.placeholder"
				:required="localParams.required"
				:style="localParams.style ? localParams.style : ''"
				:maxlength="localParams.maxlength ? localParams.maxlength : null"
				:ref="randKey"
				:name="randKey"
				:autocomplete="localParams.autocomplete || 'on'"
				v-model="localValue" 
				v-on:input="updateValue(localValue)" 
				v-on:change="fieldChanged(localValue)"
				v-on:focus="focusSet"
				v-on:keyup="keyUp(localValue)"
				v-on:blur="blur"
				v-on:click="$emit('click')">

			<slot></slot>

		</div>

		<modal-dialog
			v-if="localParams.type == 'richtext'"
			:modal-visible="cleanupModal.visible"
			title="Proposed text cleanup"
			confirm-button-text="Accept"
			cancel-button-text="Reject"
			modal-size="modal-lg"
			:working="cleanupModal.working"
			:submit-disabled="!cleanupModal.proposedHtml"
			v-on:closeModal="rejectCleanup"
			v-on:confirm="acceptCleanup">

			<accordion heading="Edit prompt & retry" class="mb-3">
				<div class="text-muted mb-2">Edit prompt and click retry to improve the result</div>
				<textarea
					style="min-height: 200px;"
					class="form-control mb-3"
					rows="12"
					v-model="cleanupModal.prompt"
					:disabled="cleanupModal.working">
				</textarea>

				<button
					type="button"
					class="btn btn-dark float-right"
					:disabled="cleanupModal.working || !cleanupModal.prompt || !cleanupModal.prompt.trim()"
					v-on:click="retryCleanup">
					Retry
				</button>

				<div style="clear: both;"></div>
			</accordion>

			<p class="text-muted mb-2" v-if="cleanupModal.working">Cleaning up text...</p>
			<template v-else-if="cleanupModal.proposedHtml">
				<p class="text-muted mb-2">Review the cleaned-up text below. Accept to replace the editor contents, or reject to keep the original.</p>
				<div class="cleanup-preview border rounded p-3" v-html="stripInlineEventHandlers(cleanupModal.proposedHtml)"></div>
			</template>
		</modal-dialog>

	</form-group>

</template>

<script type="text/javascript">

export default {
	name: "Field",
	components: {
		'ButtonGroup' : () => import("./ButtonGroup"),
		'MultiSelect' : () => import("./MultiSelect"),
		'DatePicker' : () => import("./DatePicker"),
		'DateTimePicker' : () => import("./DateTimePicker"),
		'FormGroup' : () => import("./FormGroup"),
		//'RichText' : () => import("./RichText"),
		'editor': () => import("@tinymce/tinymce-vue"),
		'PallettePicker' : () => import("./PallettePicker"),
		'FormGroup' : () => import("./FormGroup"),
		'SwitchControl' : () => import("./SwitchControl"),
		'ModalDialog' : () => import("./ModalDialog"),
		'Accordion' : () => import("./Accordion")
	},
	props: [
		/* localParams:
		{
			type: string (required),
			buttons: array (optional for button type) [
				{value: any, text: string}
			],
			options: array (optional for select type) [
				{value: any, text: string}
			],
			tabStyling: boolean, //converts button groups into tabs,
			disableNull: prevents null selection for button groups,
			step: number (optional for number type),
			min: number (optional for number type),
			max: number (optional for number type),
			size: str (optional for textarea),
			additionalEditorButtons: array (optional for editor type) [
				{
					buttonIdentifier: string
					text: string,
					action: function
				}
			] 
		}
		ACCEPTED TYPES:
			text
			textarea
			number
			richtext
			date
			datetime
			select
			native-select
			select-multi
			province
			password
			checklist
			boolean
			btn-group
			color
			color-picker
			table
		*/
		"params", //Expects: type (string), buttons (obj array)
		"value",
		"readonly",
		"colClass", //form group col-class
		"label", //form group label
		"invalid",
		"alignLabelRight",
		"floatControlRight", //if true, control will be set to float:right
		"controlLeft", //if true, label/control will be swapped, with the control on the left
		"focus",
		"loading",
		"disabled",
  ],
	data () {
		return {
			localValue: this.value,
			randKey: Math.floor(Math.random() * 10000),
			cleanupModal: {
				visible: false,
				working: false,
				proposedHtml: '',
				sourceHtml: '',
				prompt: '',
				editor: null
			},
			defaultCleanupPrompt: `You are a professional technical service report editor responsible for improving technician job notes within the Tradetraks application.

Your purpose is to correct spelling, grammar, sentence structure, and formatting while preserving the original meaning and technical accuracy of the technician's notes.

Content and Accuracy

Correct spelling, grammar, punctuation, capitalization, and sentence structure.

Improve clarity, readability, and professionalism while maintaining a natural technician writing style.

Preserve all technical details, measurements, quantities, equipment identifiers, part numbers, observations, and work performed.

Never invent, assume, exaggerate, or add information that was not provided in the original notes.

Do not change the reported outcome, equipment condition, or status of the work.

Preserve information about incomplete repairs, outstanding issues, required parts, safety concerns, and follow-up work.

Remove unnecessary repetition and filler without removing important details.

Expand abbreviations only when their meaning is clear. Preserve technical abbreviations when uncertain.

Intelligent Layout and Formatting

Analyze the content and automatically determine the most appropriate layout.

For short or simple notes, use concise, properly structured paragraphs.

For notes containing multiple tasks, findings, inspections, or repairs, use bullet points to improve readability.

Use numbered lists when the sequence of steps is important.

For detailed notes, use relevant section headings where they improve clarity.

Possible headings include:

Reported Issue

Inspection and Findings

Work Performed

Testing and Results

Outstanding Issues

Recommended Follow-Up

Only use headings supported by the information in the original notes. Do not create empty sections.

Group related information together and arrange it in a logical order.

Clearly distinguish completed work from outstanding or recommended work.

Avoid excessive formatting, unnecessary headings, nested lists, and overly long paragraphs.

Keep the length proportional to the original notes. Do not unnecessarily expand simple descriptions.

Formatting Requirements

Use clean, professional formatting suitable for display in a rich-text editor and generated PDF service reports.

Use standard paragraphs, simple headings, and single-level bullet or numbered lists where appropriate.

Maintain consistent paragraph spacing and list structure.

Avoid tables, emojis, decorative characters, excessive bold formatting, and complex layouts.

Do not introduce unnecessary HTML, inline CSS, unsupported formatting, or hidden formatting metadata.

Use only the output format supported by the application. Do not mix Markdown and HTML unless explicitly required by the application.

Output Rules

Return only the cleaned-up and formatted technician notes.

Do not include introductory statements, explanations, commentary, or descriptions of the changes.

Do not add information that was not explicitly provided or reasonably clear from the original wording.

If a statement is ambiguous, preserve its original meaning rather than guessing.

Do not imply that work was completed, equipment was tested, or an issue was resolved unless stated in the original notes.

Prioritize technical accuracy first, readability second, and formatting third.`,
			calendarMonths: [
				{value:1,text:'January'},
				{value:2,text:'February'},
				{value:3,text:'March'},
				{value:4,text:'April'},
				{value:5,text:'May'},
				{value:6,text:'June'},
				{value:7,text:'July'},
				{value:8,text:'August'},
				{value:9,text:'September'},
				{value:10,text:'October'},
				{value:11,text:'November'},
				{value:12,text:'December'},
			]
		}
	},
	watch: {
		value() {

			if (typeof this.value != "undefined") {
				if (this.localParams.type == "select-multi") 
					this.localValue = this.value.value			

				if (this.localParams.type == "select-multi" && !this.value)
					this.localValue = []
				else if (this.localParams.type == 'table' && !this.value) {
					let rowCount = (this.localParams.rows) ? this.localParams.rows.length : 1
					let colCount = (this.localParams.columns) ? this.localParams.columns.length : 1

					this.localValue = new Array(rowCount)
					for (let i = 0; i < rowCount; i++) {
						this.localValue[i] = new Array(colCount)
					}
				}
				else
					this.localValue = this.value
			}
		},
		'localValue.focus'() {
			if (this.localParams.focus)
				this.$refs[this.randKey].focus()
		},
		focus() {
			this.$refs[this.randKey].focus()
		}
	},
	methods: {
		updateValue(value) {
			this.$emit("input", value)
		},
		fieldChanged(value) {
			this.$emit("change",value)
			this.$emit("input",value)
		},
		keyUp(value) {
			this.$emit("keyup", value)
		},
		change() {
			this.$emit("change")
		},
		focusSet() {
			this.$emit("focus")
		},
		blur() {
			this.$emit("blur")
		},
		removeTableRow(index) {
			this.localValue.splice(index, 1)
			this.$emit("change")
		},
		addTableRow() {
			this.localValue.push(new Array(this.localParams.columns.length))
			this.$emit("change")
		},
		addTableColumn() {
			this.localValue.forEach(row => row.push(null))
			this.$forceUpdate()
			this.$emit("change")
		},
		requestTextCleanup(editor) {
			let html = editor.getContent()

			if (!html || !html.trim()) {
				this.alertErrors(["Editor content is empty."])
				return
			}

			this.cleanupModal.editor = editor
			this.cleanupModal.sourceHtml = html
			this.cleanupModal.prompt = this.defaultCleanupPrompt
			this.cleanupModal.visible = true
			this.runTextCleanup()
		},
		retryCleanup() {
			if (!this.cleanupModal.sourceHtml || !this.cleanupModal.prompt || !this.cleanupModal.prompt.trim())
				return

			this.runTextCleanup()
		},
		runTextCleanup() {
			this.cleanupModal.working = true
			this.cleanupModal.proposedHtml = ''

			this.postData("AIConnection/text-cleanup", {
				html: this.cleanupModal.sourceHtml,
				prompt: this.cleanupModal.prompt
			}, true).then(response => {
				this.cleanupModal.working = false

				if (response.success && response.data && response.data.html) {
					this.cleanupModal.proposedHtml = response.data.html
					return
				}
			})
		},
		acceptCleanup() {
			if (!this.cleanupModal.editor || !this.cleanupModal.proposedHtml)
				return

			let html = this.cleanupModal.proposedHtml

			this.cleanupModal.editor.setContent(html)
			this.localValue = html
			this.updateValue(html)

			this.rejectCleanup()
		},
		rejectCleanup() {
			this.cleanupModal.visible = false
			this.cleanupModal.proposedHtml = ''
			this.cleanupModal.sourceHtml = ''
			this.cleanupModal.prompt = ''
			this.cleanupModal.editor = null
			this.cleanupModal.working = false
		},
		tinymceInit() {

			let vm = this

			let toolbar = 'textcleanup | bold bullist numlist | undo redo | code | linebreak | horizontalline' 

			if ("additionalEditorButtons" in vm.params && vm.params.additionalEditorButtons.length > 0) {
				vm.params.additionalEditorButtons.forEach(button => {
					toolbar += " | "+button.buttonIdentifier
				})
			}

			return {	
				plugins: 'link lists advlist hr code pagebreak autoresize paste contextmenu',
				toolbar,
				menubar: false, 
				contextmenu: true,
				browser_spellcheck: true,
				branding: false,
				invalid_styles: 'color font-size background-color font-family list-style-type line-height vertical-align margin margin-top margin-bottom margin-left margin-right',
				invalid_elements: 'span script style link div',
				
				setup: function (editor) {
					editor.ui.registry.addButton('linebreak', {
						text: 'BR',
						onAction: () => {
							editor.insertContent('<br>');
						}
					})

					editor.ui.registry.addButton("horizontalline", {
						text: "---LINE---",
						onAction: () => {
							editor.insertContent('<hr>');
						}
					})

					editor.ui.registry.addButton('textcleanup', {
						text: 'AI Cleanup',
						tooltip: 'Clean up text',
						onAction: () => {
							vm.requestTextCleanup(editor)
						}
					})

					editor.on('init', () => {
						let cleanupButton = editor.getContainer().querySelector('button[aria-label="Clean up text"]')
						if (cleanupButton)
							cleanupButton.style.backgroundColor = '#e8dff5'
					})

					if ("additionalEditorButtons" in vm.params && vm.params.additionalEditorButtons.length > 0) {
						vm.params.additionalEditorButtons.forEach(button => {

							editor.ui.registry.addButton(button.buttonIdentifier, {
								text: button.text,
								onAction: () => {
									button.action(editor)	
								} 
							})

						})
					}
				}
				
			}
		}
	},
	computed: {
		provincesAndStates() {
			return [
				{text: "None", value: "N/A"},
				...this.provincesList,
				{text: "-",value: null, disabled: true},
				...this.statesList,
				{text: 'Other', value: "Other"}
			]
		},
		localParams() {
			if (!this.params)
				return {type:'text'}

			let localParams = this.params

			if ("options" in localParams && localParams.options && "selectedLabel" in localParams && localParams.selectedLabel) {
				//push seleted label as the top option in options
				localParams.options.unshift({value:this.value,text: localParams.selectedLabel})
			}

			return localParams
		},
		textareaClasses() {
			let classText = ""

			if ("size" in this.params)
				classText += this.params.size

			if (this.invalid)
				classText += " invalid"

			return classText
		},
		fieldClass () {
			//Compute the field column size from the label column size
			let num_cols_arry = this.colClass.split("-")
			let num_cols = parseInt(num_cols_arry[2])

			let difference_cols = 12 - num_cols

			return "col-md-"+difference_cols
		},
		selectReadonlyValue() {

			let vm = this

			let selectedObj

			//determine if the options are grouped
			if (this.localParams.options.length > 0) {
				if (typeof this.localParams.options[0] == 'object' && "groupValues" in this.localParams.options[0]) {
					this.localParams.options.forEach(group => {

						let foundInGroup = group.groupValues.find(opt => opt.value == vm.localValue)

						if (foundInGroup)
							selectedObj = foundInGroup
					})
				}
				else if (typeof this.localParams.options[0] == 'string')
					return this.localParams.options.find(opt => opt == this.localValue)
				else 
					selectedObj = this.localParams.options.find(opt => opt.value == this.localValue)
				
			}

			if (selectedObj)
				return selectedObj.text

			return ""
		}
	},
	mounted() {
		if (this.localParams.focus)
			this.$refs[this.randKey].focus()
	},
	created() {
		if (this.localParams.type == "select-multi" && !this.value) 
			this.localValue = []
		else if (this.localParams.type == 'table') {
			let rowCount = (this.localParams.rows) ? this.localParams.rows.length : 1
			let colCount = (this.localParams.columns) ? this.localParams.columns.length : 1

			if (!this.value) {
				//init table values
				this.localValue = new Array(rowCount)
				for (let i = 0; i < rowCount; i++) {
					this.localValue[i] = new Array(colCount)
				}
			}
			else {
				//make sure each row has the correct number of columns
				this.value.forEach((row,index) => {
					if (row.length < colCount) {
						for (var i = row.length; i < colCount; i++) {
							row.push("")
						}
					}
				})
			}
		}
		else
			this.localValue = this.value

		if (this.randKey in this.$refs && this.$refs[this.randKey])
			this.$refs[this.randKey].focus()

	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style type="text/css" scoped>
	textarea, pre {
		min-height:100px;
	}

	textarea.xxsm, pre.xxsm {
		height: 38px;
		min-height: 38px;
		padding: 5px;
	}

	textarea.xsm, pre.xsm {
		min-height: 48px;
		height: 48px;
	}

	textarea.sm, pre.sm {
		min-height:80px; 
	}

	textarea.md, pre.md {
		min-height: 100px;
	}

	textarea.lg, pre.lg {
		min-height: 150px;
	}

	textarea.xlg, pre.xlg {
		min-height: 250px;
	}

	input, textarea, select, .btn-lg, .btn-group-lg>.btn {
		border-radius: 0;
	}

	.invalid {
		border-left: 2px solid #ff8f8f;
	}

	.readonly-pre {
		padding: 10px;
		/*box-shadow: inset 0 0 4px #efefef;
		background-color: #f8f9fa;
		border: 1px solid #ced4da;*/
		word-wrap: break-word;
		white-space: pre-wrap;
		font-family: inherit;
		font-size: 100%;
		border-left: 1px solid #e0e0e0;
		padding-right: 0;
		background: #fff;
	}

	.readonly-div {
		padding: 10px;
		/*box-shadow: inset 0 0 4px #efefef;
		background-color: #f8f9fa;
		border: 1px solid #ced4da;*/
		word-wrap: break-word;
		font-family: inherit;
		font-size: 100%;
		border-left: 1px solid #e0e0e0;
		padding-right: 0;
		background: #fff;
	}

	.checkbox-container {
		display: inline-block;
		min-width: 300px;
		width: 50%;
		vertical-align: top;
	}

	.checkbox-container.checkbox-container-horizontal {
		width: auto;
		min-width: 0;
		margin-right: 15px;
	}

	.editable-static, .editable-static input {
		cursor: pointer!important;
	}

	.editable-static .fa-pencil-alt {
		opacity: 0.7;
	}

	.editable-static:hover .fa-pencil-alt {
		opacity: 1;
	}

	input.form-control[type=number] {
		padding-right: 1px;
	}

	input.form-control[type=color] {
		width: 60px;
		padding: 0;
		cursor: pointer;
	}

	label.switch-label {
		margin: 0;
		margin-left: 10px;
		margin-right: 10px;
		font-weight: bold;
	}

	.cleanup-preview {
		max-height: 60vh;
		overflow-y: auto;
		background: #fff;
	}
</style>